module.exports = ($scope, $uibModalInstance, $analytics, source, image) ->

  $scope.close = ->
    $analytics.eventTrack "Clicked close",
      category: "Source Info modal"
    $uibModalInstance.close()
    return

  $scope.source = source
  $scope.image = image
